import faqContent from '../content/faqs.json';

export interface FaqItem { question: string; answer: string; }
export const homeFaqs = faqContent.home as FaqItem[];
